export const vsLookupManagementServiceName = "projectCostLookupManagementService";
export const vsLookupManagementServiceProviderName = `${vsLookupManagementServiceName}Provider`;
